import Model from 'src/storage/base';
import { upperFirstCharAll } from 'src/helpers';

class SignupClinicPopupModel extends Model {
  id = 'SignupClinicPopupModel';
  persistent = false;
  defaultState = () => ({});

  apiConfig = {
    updateSpecialist: {
      url: 'profile/update/doctor/specialist',
      validation: {
        specialist: 'specialist',
        description: 'description',
        subSpeciality: 'subSpeciality'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleProfile',
    location: 'initLocation'
  };

  initLocation = (data) => {
    this.setState({
      tempAddress: {
        countryAddress: upperFirstCharAll(data.country) + '_' + data.countryCode,
        countryName: data.country
      }
    });
    this.loadLocation();
  };

  loadLocation = () => {
    if (model.input('countryAddress') === '') {
      this.setState({ ...this.state.tempAddress });
    }
  };

  saveSpeciality(cb) {
    let { description, specialist, subSpeciality } = this.state;
    this.api(
      'updateSpecialist',
      { description, specialist, subSpeciality },
      (err, data, success) => {
        if (success) this.emit('profile', data);
        cb && cb(err, data, success);
      }
    );
  }

  handleProfile = (profile) => {
    this.setStateSilent({ ...profile, profile });
  };
  handleChangeProfile = (key, value) => {
    this.handleChange(key, value);
  };
}

const model = new SignupClinicPopupModel();
export default model;
